import { render, staticRenderFns } from "./Entitysettings.vue?vue&type=template&id=527cdda6&scoped=true&"
import script from "./Entitysettings.vue?vue&type=script&lang=js&"
export * from "./Entitysettings.vue?vue&type=script&lang=js&"
import style0 from "./Entitysettings.vue?vue&type=style&index=0&id=527cdda6&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527cdda6",
  null
  
)

export default component.exports